export default "__VITE_ASSET__NPiZedrz__"